/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 */

import { MenuGroup } from '@zcode-ui/shadz-ui'
import React from 'react'
import { TRACK_NAVBAR_ACTION } from '../../../../constants'
import type { OnNavLinkClickProps, SubmenuType } from '../../../../types'
import { UserMenuBtnRow } from '../../SharedComponents'

interface AmenitiesUserSubmenuProps {
  handleSetActiveSubmenu: (navLinkClickProps: OnNavLinkClickProps, submenu: SubmenuType) => void
}

export const AmenitiesUserSubmenu = ({ handleSetActiveSubmenu }: AmenitiesUserSubmenuProps) => {
  const showAFRCheapMenu = () =>
    handleSetActiveSubmenu(
      {
        trackAction: TRACK_NAVBAR_ACTION.AFR_CHEAP,
      },
      'smAFRCheap'
    )
  const showAFRLuxuryMenu = () =>
    handleSetActiveSubmenu(
      {
        trackAction: TRACK_NAVBAR_ACTION.AFR_LUXURY,
      },
      'smAFRLuxury'
    )
  const showAFRPetFriendlyMenu = () =>
    handleSetActiveSubmenu(
      {
        trackAction: TRACK_NAVBAR_ACTION.AFR_PET_FRIENDLY,
      },
      'smAFRPetFriendly'
    )
  const showAFRShortTermMenu = () =>
    handleSetActiveSubmenu(
      {
        trackAction: TRACK_NAVBAR_ACTION.AFR_SHORT_TERM,
      },
      'smAFRShortTerm'
    )
  return (
    <MenuGroup>
      <UserMenuBtnRow onClick={showAFRShortTermMenu}>Short Term Rentals</UserMenuBtnRow>
      <UserMenuBtnRow onClick={showAFRLuxuryMenu}>Luxury Apartments</UserMenuBtnRow>
      <UserMenuBtnRow onClick={showAFRPetFriendlyMenu}>Pet-friendly Apartments</UserMenuBtnRow>
      <UserMenuBtnRow onClick={showAFRCheapMenu}>Cheap Apartments</UserMenuBtnRow>
    </MenuGroup>
  )
}
